module.exports = __webpack_public_path__ + "img/people.a812c557.svg";